"use client";

import { useEffect } from "react";
import { tracker } from "@/lib/tracker";

interface TrackEventProps {
  type: string;
  data?: Record<string, unknown>;
}

/**
 * Drop into any server page to fire a tracking event on mount.
 * Example: <TrackEvent type="boat_view" data={{ id: 5, name: "Fantail 217" }} />
 */
export function TrackEvent({ type, data }: TrackEventProps) {
  useEffect(() => {
    tracker.event(type, data);
  }, [type, data]);

  return null;
}
